import React from 'react';
import Picto from '../../../../Components/Picto';
import {
	iconAbandonedCart,
	iconHistory,
	iconRecommendation
} from '../../../../Components/CustomIcon/CustomIcon';
import { listRulesByType } from '../context/RuleType';

export default function RuleTypePicto({
	size,
	value
}) {

	function getIcon(iconName) {
		if (iconName === 'abandonedCart') return iconAbandonedCart;
		if (iconName === 'history') return iconHistory;
		return iconRecommendation;
	}

	function getColor(color) {
		return color || 'orange';
	}

	const ruleType = listRulesByType.find(t => t.value === value);

	return (
		<Picto
			size={size}
			iconCustom={getIcon(ruleType?.pictoIcon)}
			color={getColor(ruleType?.pictoColor)}
		/>
	);
}